import { Http } from '../../../support';

export const initialState = {
  busy: false,
  data: {
    tipo: 'autofacturacion',
  },
  progress: 0,
  result: undefined,
  error: undefined,
};

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.upload = { ...initialState };
  });
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.upload.data = {
      ...state.modulo.autofacturacion.upload.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.autofacturacion.upload.progress = progress;
  });
};

const upload = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.modulo.autofacturacion.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { data } = store.state.modulo.autofacturacion.upload;

    let formData = new FormData();

    formData.append('file', data.file);
    formData.append('tipo', data.tipo);

    const response = await Http.post(`${window.BONJOUR_URL}/api/autofacturacion`, formData, options);

    store.setState((state) => {
      state.modulo.autofacturacion.upload.busy = false;
      state.modulo.autofacturacion.upload.progress = 100;
      state.modulo.autofacturacion.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.autofacturacion.upload.busy = false;
      state.modulo.autofacturacion.upload.error = error.data || error;
    });
  }
};

const AutofacturacionUploadStore = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload,
  },
};

export default AutofacturacionUploadStore;
